<template>
    <template v-if="goalType.name">
        <div class="box-header">
            <p class="goal-type-heading">
                {{ goalType.position }}. {{ goalType.name }}
            </p>
            <p v-if="goalType.description"
               class="goal-type-sub-heading">
                {{ goalType.description }}
            </p>
        </div>
    </template>
    <recovery-goal-blocks v-model="goalType.recoveryGoalBlocks"
                          :patient-id="patientId"
                          :goal-type-id="goalType.goalPlanRecoveryGoalTypeId"
                          :edit-state="editState"
                          :review-statuses="reviewStatuses"
                          :can-be-reviewed="goalType.canBeReviewed"
                          :url-head="urlHead"
                          :goal-plan-id="goalType.goalPlanId"
                          @delete-pressed="deletePressed" />
</template>

<script setup>
    import { defineProps, defineEmits, computed, ref, onMounted } from 'vue';
    import recoveryGoalBlocks from "./RecoveryGoalBlocks.vue";

    const props = defineProps({
        modelValue: {
            type: Array,
            default: null
        },
        patientId: {
            type: Number,
            default: 0
        },
        editState: {
            type: Number,
            default: 0
        },
        reviewStatuses: {
            type: Array,
            default: null
        },
        urlHead: {
            type: String,
            default: null
        }
    });

    const emit = defineEmits(['update:modelValue']);

    const goalType = computed({
        get: () => props.modelValue,
        set: newValue => emit("update:modelValue", newValue)
    });

    onMounted(() => {
        console.log('RecoveryGoalType - goalType:', goalType.value);
    });

</script>

<style scoped>
    .goal-type-heading {
        font-size: 120%;
        font-weight: bold;
    }

    .goal-type-sub-heading {
        font-size: 110%;
        font-weight: bold;
    }
</style>